import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  root: {
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    paddingBottom: '20px',
  },
  item: {
    display: 'table-cell',
    minWidth: 350,
    [theme.breakpoints.up('xs')]: {
      display: 'table-cell',
      minWidth: '200',
    },
  },
});

function HorizontalSlider(props) {
  const { children, classes } = props;
  return (
    <Grid className={classes.root} container wrap="nowrap" spacing={16}>
      {React.Children.map(children, (child, i) => (
        <Grid className={classes.item} key={i} item xs={12}>
          {child}
        </Grid>
      ))}
    </Grid>
  );
}

HorizontalSlider.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HorizontalSlider);
